const isQueryTag = (searchString: string): boolean => {
    return searchString.endsWith(':')
}

export default isQueryTag
